import { registerIcons } from 'mussel'

import stAccessDenied from './status/access-denied.svg'
import stFatalError from './status/fatal-error.svg'
import stLoadingFail from './status/loading-fail.svg'
import stNetworkError from './status/network-error.svg'
import stNoData from './status/no-data.svg'
import stNoMessage from './status/no-message.svg'
import stNoResult from './status/no-result.svg'
import stNotFound from './status/not-found.svg'

registerIcons({
  stAccessDenied,
  stFatalError,
  stLoadingFail,
  stNetworkError,
  stNoData,
  stNoMessage,
  stNoResult,
  stNotFound
})
